module.exports = __webpack_public_path__ + "static/media/venue.c90f290c.svg";